// Renders a profile photo, optionally wrapped in a colored/gradient ring
// from an equipped "border" shop item. With no item, falls back to a plain
// image (or whatever border style the caller passes through). With no
// photoURL (e.g. the admin's item-builder preview, which isn't tied to any
// one user), falls back to a plain grey circle instead of a broken <img>.
//
// Total footprint is ALWAYS exactly `size` x `size`, border or no border,
// thick ring or thin ring — the ring is inset (the photo shrinks to make
// room for it) rather than added on top (which used to grow the box).
// Two avatars side by side with the same `size` but different equipped
// borders would otherwise end up different overall sizes and drift apart
// in any layout that assumes a fixed box (e.g. the vs. reveal screen).
function AvatarRing({ photoURL, size, item, fallbackBorder }) {
  // width/height: 100% (rather than a fixed pixel size) lets the photo
  // automatically fill whatever's left of the box after box-sizing:
  // border-box subtracts the ring's own border width — so it always
  // perfectly fills its circle, regardless of ring thickness.
  const photoStyle = { width: "100%", height: "100%", borderRadius: "50%", display: "block", objectFit: "cover", objectPosition: "center" };
  const photo = photoURL
    ? <img src={photoURL} alt="" style={photoStyle} />
    : <div style={{ width: "100%", height: "100%", borderRadius: "50%", background: "#d8dae3" }} />;

  if (!item) {
    return (
      <div style={{ width: size, height: size, borderRadius: "50%", border: fallbackBorder, boxSizing: "border-box", overflow: "hidden", flexShrink: 0 }}>
        {photo}
      </div>
    );
  }

  const { colorFrom, colorTo, thickness } = item.config || {};
  const ringWidth = Number(thickness) > 0 ? Number(thickness) : 3;
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%", flexShrink: 0, boxSizing: "border-box",
      background: `linear-gradient(135deg, ${colorFrom}, ${colorTo || colorFrom})`,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{ width: size - ringWidth * 2, height: size - ringWidth * 2, borderRadius: "50%", border: "2px solid #fff", boxSizing: "border-box", overflow: "hidden" }}>
        {photo}
      </div>
    </div>
  );
}

export default AvatarRing;
